













































import {
  defineComponent, ref, computed, Ref, watch, reactive, onMounted,
} from '@vue/composition-api';
import { useQuery, useResult } from '@vue/apollo-composable';
import { useFormat } from 'vivat';
import { mapChart } from 'highcharts';
import _ from 'lodash';

import getRegionSumWeight from '@/gql/dashboard/getRegionSumWeight.gql';

import useHighChartMap from '@/useHighChartMap';
import mapData from '@/components/Map/th-all.geo.json';

const DeliveryHeatMap = defineComponent({
  props: {
    maxWidth: {
      type: String,
      default() { return '800'; },
    },
  },
  setup() {
    const { getProperty } = useHighChartMap();
    const NOW = useFormat.date().computerShortDate();
    // eslint-disable-next-line
    const toCurrency = (string: string | number) => parseFloat(string as string || '0').toLocaleString('th-TH', { minimumFractionDigits: 0, maximumFractionDigits: 2 });
    const isUserZoom: Ref<boolean> = ref(false);
    const { result: getOverallDailyReportResult, loading } = useQuery(getRegionSumWeight, computed(() => ({
      date: NOW,
    })), () => ({ fetchPolicy: 'network-only' }));
    const regions = reactive([
      { regionId: 1, deliveryCount: 0, weightSum: 0 },
      { regionId: 2, deliveryCount: 0, weightSum: 0 },
      { regionId: 3, deliveryCount: 0, weightSum: 0 },
      { regionId: 4, deliveryCount: 0, weightSum: 0 },
      { regionId: 5, deliveryCount: 0, weightSum: 0 },
      { regionId: 6, deliveryCount: 0, weightSum: 0 },
    ]);
    const _regions = useResult(getOverallDailyReportResult, [], (data: any) => data.overallDailyReport.regions);
    watch(() => getOverallDailyReportResult.value, () => {
      if (!loading.value && _regions.value !== []) {
        _regions.value.forEach((region: {
          regionId: number; deliveryCount: number; weightSum: number;
        }) => {
          for (let i = 0; i < 6; i += 1) {
            if (region.regionId === regions[i].regionId) {
              regions[i].deliveryCount = region.deliveryCount;
              regions[i].weightSum = region.weightSum;
            }
          }
        });
        // eslint-disable-next-line
        renderChart();
      }
    });
    const _provinces = useResult(getOverallDailyReportResult, [], (data: any) => data.overallDailyReport.provinces);
    const computedData = computed(() => {
      const _value: any = {
        northern: [],
        northeastern: [],
        central: [],
        eastern: [],
        western: [],
        southern: [],
      };

      function pushToArray(_region: string, province: string | number, value: number | string) {
        if (_region === 'NORTHERN') _value.northern.push([`th-${province}`, value]);
        if (_region === 'NORTHEASTERN') _value.northeastern.push([`th-${province}`, value]);
        if (_region === 'CENTRAL') _value.central.push([`th-${province}`, value]);
        if (_region === 'EASTERN') _value.eastern.push([`th-${province}`, value]);
        if (_region === 'WESTERN') _value.western.push([`th-${province}`, value]);
        if (_region === 'SOUTHERN') _value.southern.push([`th-${province}`, value]);
      }

      const hasValue: number[] = [];
      _provinces.value.forEach((elm: any) => {
        hasValue.push(elm.provinceId);
        const { shortForm, region } = getProperty(elm.provinceId);
        pushToArray(region, shortForm, elm.weightSum);
      });
      for (let i = 0; i < 78; i += 1) {
        if (hasValue.indexOf(i) === -1) {
          const { shortForm, region } = getProperty(i);
          pushToArray(region, shortForm, 0);
        }
      }
      return _value;
    });
    // const provincesList = ref(mapData.features.map((item: any) => item.id));

    const regionColors = {
      northern: '#ffc2c2',
      'northern-text': '#b51818',
      northeastern: '#ffdc96',
      'northeastern-text': '#e0a328',
      central: '#bbffb5',
      'central-text': '#3dbf32',
      eastern: '#61ffef',
      'eastern-text': '#1cb8a9',
      western: '#85beff',
      'western-text': '#4099ff',
      southern: '#e2b5ff',
      'southern-text': '#ae2bff',
      class: 'stroke-1 font-bold text-xs',
    };
    const chartDataLabel = {
      northern: { enabled: true, format: `<span style="color: ${regionColors['northern-text']};" class="${regionColors.class}">{point.name}</span>` },
      northeastern: { enabled: true, format: `<span style="color: ${regionColors['northeastern-text']};" class="${regionColors.class}">{point.name}</span>` },
      central: { enabled: true, format: `<span style="color: ${regionColors['central-text']};" class="${regionColors.class}">{point.name}</span>` },
      eastern: { enabled: true, format: `<span style="color: ${regionColors['eastern-text']};" class="${regionColors.class}">{point.name}</span>` },
      western: { enabled: true, format: `<span style="color: ${regionColors['western-text']};" class="${regionColors.class}">{point.name}</span>` },
      southern: { enabled: true, format: `<span style="color: ${regionColors['southern-text']};" class="${regionColors.class}">{point.name}</span>` },
    };
    const chartTooltip = {
      headerFormat: '',
      pointFormat: '<b>{point.name}</b> <br> น้ำหนัก: {point.value} กิโลกรัม',
    };
    /* eslint-disable */
    const chartOptions = computed(() => ({
      chart: {
        map: mapData,
        height: 830,
        width: 700,
        events: {
          click: ($event: {
            dataMax: number; dataMin: number; max: number; min: number;
          }) => {
            isUserZoom.value = !isUserZoom.value;
          },
        },
      },
      title: {
        text: 'แผนที่แสดงจำนวนบิล และน้ำหนักค้างส่ง',
      },
      subtitle: {
        text: '',
      },
      mapNavigation: {
        enabled: true,
        buttonOptions: {
          alignTo: 'spacingBox',
        },
      },
      xAxis: [{
        accessibility: {
          enabled: false,
        },
        events: {
          afterSetExtremes: ($event: {
            dataMax: number; dataMin: number; max: number; min: number;
          }) => {
            console.log('dsads');
            if ($event.max > $event.dataMax) isUserZoom.value = false;
            else isUserZoom.value = true;
          },
          setExtremes: ($event: {
            dataMax: number; dataMin: number; max: number; min: number;
          }) => {
            console.log('dsads');
            if ($event.max > $event.dataMax) isUserZoom.value = false;
            else isUserZoom.value = true;
          },
        },
      }],
      yAxis: [{
        accessibility: {
          enabled: false,
        },
        events: {
          afterSetExtremes: ($event: {
            dataMax: number; dataMin: number; max: number; min: number;
          }) => {
            console.log('dsads');
            if ($event.max > $event.dataMax) isUserZoom.value = false;
            else isUserZoom.value = true;
          },
          setExtremes: ($event: {
            dataMax: number; dataMin: number; max: number; min: number;
          }) => {
            console.log('dsads');
            if ($event.max > $event.dataMax) isUserZoom.value = false;
            else isUserZoom.value = true;
          },
        },
      }],
      colorAxis: [
        {
          min: 1,
          minColor: '#ecf8ff',
          maxColor: '#113561',
        },
      ],
      loading: {
        hideDuration: 100000,
        showDuration: 100000,
      },
      series: [
        {
          name: 'CENTRAL',
          allAreas: false,
          states: {
            hover: { color: regionColors.central },
          },
          color: regionColors.central,
          dataLabels: chartDataLabel.central,
          data: computedData.value.central,
          tooltip: chartTooltip,
        },
        {
          name: 'NORTHERN',
          allAreas: false,
          states: {
            hover: { color: regionColors.northern },
          },
          color: regionColors.northern,
          dataLabels: chartDataLabel.northern,
          data: computedData.value.northern,
          tooltip: chartTooltip,
        },
        {
          name: 'WESTERN',
          allAreas: false,
          states: {
            hover: { color: regionColors.western },
          },
          color: regionColors.western,
          dataLabels: chartDataLabel.western,
          data: computedData.value.western,
          tooltip: chartTooltip,
        },
        {
          name: 'eastern',
          allAreas: false,
          states: {
            hover: { color: regionColors.eastern },
          },
          color: regionColors.eastern,
          dataLabels: chartDataLabel.eastern,
          data: computedData.value.eastern,
          tooltip: chartTooltip,
        },
        {
          name: 'northeastern',
          allAreas: false,
          states: {
            hover: { color: regionColors.northeastern },
          },
          color: regionColors.northeastern,
          dataLabels: chartDataLabel.northeastern,
          data: computedData.value.northeastern,
          tooltip: chartTooltip,
        },
        {
          name: 'southern',
          allAreas: false,
          states: {
            hover: { color: regionColors.southern },
          },
          color: regionColors.southern,
          dataLabels: chartDataLabel.southern,
          data: computedData.value.southern,
          tooltip: chartTooltip,
        },
      ],
    }));

    const renderChart = _.debounce(() => {
      mapChart('chart', chartOptions.value as any);
    }, 200);

    onMounted(() => {
      renderChart();
    });

    return {
      toCurrency,

      regions,
      isUserZoom,

      chartOptions,
      computedData,
      renderChart,

      regionColors,
    };
  },
});

export default DeliveryHeatMap;
